import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import styles from "./SendConsentComplete.module.scss";
import { FiCopy } from "react-icons/fi";
import confetti from "canvas-confetti";

export default function SendConsentComplete() {
  const navigate = useNavigate();
  const { id } = useParams();

  // 🎉 Confetti from sides only (no center burst)
  useEffect(() => {
    const duration = 4000;
    const end = Date.now() + duration;

    const colors = [
      "#ff595e", "#ffca3a", "#8ac926",
      "#1982c4", "#6a4c93", "#ff9f1c",
      "#4ecdc4", "#feca57", "#ff6b6b",
    ];

    const frame = () => {
      // left burst
      confetti({
        particleCount: 12,
        startVelocity: 45,
        spread: 80,
        origin: { x: 0.1, y: Math.random() - 0.2 },
        colors,
      });
      // right burst
      confetti({
        particleCount: 12,
        startVelocity: 45,
        spread: 80,
        origin: { x: 0.9, y: Math.random() - 0.2 },
        colors,
      });

      if (Date.now() < end) requestAnimationFrame(frame);
    };
    frame();
  }, []);

  const patientBaseUrl = process.env.REACT_APP_PATIENT_URL ;
  const link = `${patientBaseUrl}/${id}`;

  const handleCopy = () => {
    navigator.clipboard.writeText(link);
    alert("Link copied to clipboard!");
  };

  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <img
          src="https://cdn-icons-png.flaticon.com/512/2278/2278992.png" 
          alt="Celebration"
          className={styles.illustration}
        />

        <h1 className={styles.title}>
          Well done! Your consent form has been emailed 
        </h1>

        <div className={styles.card}>
          <h2>Email sent successfully</h2>
          
          <p>
            We’ve provided your patient with a secure link to view and complete their consent documents. If you’d like to resend the form manually via email or text, simply copy the link below.
          </p>
          <p className={styles.link}>{link}</p>

          <button className={styles.copyBtn} onClick={handleCopy}>
            <FiCopy size={16} />
            Copy link
          </button>
        </div>

        <div className={styles.actions}>
          <button
            className={styles.primaryBtn}
            onClick={() => navigate(`/summary-new/${id}`)}
          >
            View summary
          </button>
          <button
            className={styles.secondaryBtn}
            onClick={() => navigate("/new-dashboard")}
          >
            Go to dashboard
          </button>
        </div>
      </div>
    </div>
  );
}
